/**
 * Configuration constants for the top navigation bar
 */

/**
 * The height set off for the top nav bar
 */
export const TOP_NAV_HEIGHT = '57px';

/**
 * The zIndex to set to be able to be over the menu
 */
export const FullScreenZIndex = 1400;

/**
 * The zIndex of the top nav bar
 */
export const TopNavBarZIndex = FullScreenZIndex - 10;

/**
 * The zIndex for floating components of the top nav bar
 */
export const TopNavBarFloatingComponentsZIndex = TopNavBarZIndex + 1000;

/**
 * Lite/Standard version toggle
 */
export const TOP_NAV_BAR_LITE_VERSION = false;
